import { type ReactNode } from 'react';
import { cn } from '../utils';
import { Filter } from 'lucide-react';

export function FilterBar({ actions, className, children }: { actions?: ReactNode; className?: string; children: ReactNode }) {
	return (
		<div className={cn('flex flex-row rounded-lg border border-gray-200 bg-white px-4 py-3 gap-6', className)}>
			<div className="flex items-center gap-1.5 text-xs text-gray-500">
				<Filter size={12} />
				Filters:
			</div>
			<div className="flex flex-wrap items-end gap-x-5 gap-y-3">
				{children}
				{actions && <div className="ml-auto flex min-h-[42px] shrink-0 items-center gap-2">{actions}</div>}
			</div>
		</div>
	);
}

function FilterBarItem({ label, className, children }: { label?: string; className?: string; children: ReactNode }) {
	return (
		<div className={cn('flex flex-col gap-1', className)}>
			{label && <span className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</span>}
			<div className="flex min-h-[42px] items-center gap-2">{children}</div>
		</div>
	);
}

function FilterBarSeparator({ children = 'to' }: { children?: ReactNode }) {
	return <span className="text-sm text-gray-400">{children}</span>;
}

FilterBar.Item = FilterBarItem;
FilterBar.Separator = FilterBarSeparator;
